import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import styles from "./Deliverables.module.css";

function DeliverableCard({
  title,
  description,
  className,
}: {
  title: string;
  description: string;
  className?: string;
}) {
  return (
    <details className={className ? `${styles.card} ${className}` : styles.card}>
      <summary>
        <h3>{title}</h3>
        <svg
          className={styles.chevron}
          width={24}
          height={24}
          viewBox="0 -960 960 960"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z" />
        </svg>
      </summary>
      <p>{description}</p>
    </details>
  );
}

export function Deliverables() {
  const { deliverables } = useMaestriaContent();
  const [card1, card2, card3, card4] = deliverables.cards;
  const [titleHead, titleStrong] = deliverables.title.split(/(?=você vai receber|you will receive)/);
  const [bonusHead, ...bonusRest] = deliverables.bonus.title.split(" ");

  return (
    <section
      id="entregaveis"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="deliverables-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <div className={styles.mosaic}>
          <div className={`${styles.row} ${styles.rowA}`}>
            <DeliverableCard
              className={styles.cardFirst}
              title={card1.title}
              description={card1.description}
            />
            <DeliverableCard title={card2.title} description={card2.description} />
          </div>

          <div className={`${styles.row} ${styles.rowB}`}>
            <DeliverableCard title={card3.title} description={card3.description} />
            <DeliverableCard title={card4.title} description={card4.description} />
          </div>

          <aside className={styles.bonus}>
            <img
              className={styles.bonusArt}
              src={deliverables.bonus.icon}
              alt=""
              aria-hidden="true"
              width={202}
              height={202}
              loading="lazy"
            />
            <div className={styles.bonusCopy}>
              <h3>
                {bonusHead}
                <span className={styles.bonusAccent}> {bonusRest.join(" ")}</span>
              </h3>
              <p>{deliverables.bonus.description}</p>
            </div>
          </aside>
        </div>

        <div className={styles.copy}>
          <h2 id="deliverables-title" className={styles.title}>
            {titleHead}
            <strong>{titleStrong}</strong>
          </h2>
          <p className={styles.note}>{deliverables.note}</p>
        </div>
      </div>
    </section>
  );
}
